<div #siqNotification siqGrid fx-direction="row" fx-layout-align="start center" class="notification-container background-white br-6 mx-12">
  <div siqGrid fx-layout-align="center center" [class]="notificationClasses">
    <img class="notification-icon" [src]="icon" alt="icon">
  </div>
  <div siqGrid fx-layout-align="center center" class="text-container p-12">
    <span class="siq-text-700 fs-14 secondary">{{ text }}</span>
  </div>
</div>
